import { useEffect, useState } from "react";
import { collection, query, orderBy, limit, onSnapshot, writeBatch, doc } from "firebase/firestore";
import { db } from "../lib/firebase";

export function useNotifications(userId) {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!userId) {
      setNotifications([]);
      setUnreadCount(0);
      return;
    }

    const q = query(
      collection(db, "notifications", userId, "items"),
      orderBy("createdAt", "desc"),
      limit(20)
    );

    const unsub = onSnapshot(q, (snap) => {
      const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setNotifications(items);
      setUnreadCount(items.filter((n) => !n.read).length);
    });

    return unsub;
  }, [userId]);

  const markAllRead = async () => {
    if (!userId || unreadCount === 0) return;
    const batch = writeBatch(db);
    notifications
      .filter((n) => !n.read)
      .forEach((n) => {
        batch.update(doc(db, "notifications", userId, "items", n.id), { read: true });
      });
    await batch.commit();
  };

  return { notifications, unreadCount, markAllRead };
}

export function formatNotifTime(ts) {
  if (!ts) return "";
  const date = ts.toDate ? ts.toDate() : new Date(ts);
  const diff = Date.now() - date.getTime();
  if (diff < 60000) return "just now";
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
  return `${Math.floor(diff / 86400000)}d ago`;
}

// Helper to write a notification from admin actions
export async function writeNotification(db, userId, type, message) {
  const { addDoc, serverTimestamp } = await import("firebase/firestore");
  await addDoc(collection(db, "notifications", userId, "items"), {
    type,
    message,
    read: false,
    createdAt: serverTimestamp(),
  });
}
